import ReactSelect, {
	components as defaultReactSelectComponent,
} from "react-select";
import { Loader } from "../loader/loader";
import {
	getReactSelectStyles,
	OptionWithCheckBox,
} from "./react-select-styles";

type SelectProps = {
	name?: string;
	value?: any;
	error?: string | boolean;
	isTouched?: boolean;
	options?: any;
	checkByLabel?: boolean;
	isMulti?: boolean;
	components?: any;
	isGroup?: boolean;
	placeholder?: string;
	[key: string]: any;
	onChange?: (value?: any) => void;
	onBlur?: (value?: any) => void;
	onInputChange?: (value?: any) => void;
};

const Select = ({
	name,
	value,
	error,
	isTouched,
	options,
	checkByLabel,
	isMulti,
	components,
	isGroup,
	onChange,
	onBlur,
	...rest
}: SelectProps) => {
	return (
		<div className="input-container">
			<ReactSelect
				onChange={onChange}
				data-testid={name ? `select-${name}` : undefined}
				onBlur={onBlur}
				onInputChange={(inputValue: any) =>
					inputValue.length <= 25 ? inputValue : inputValue.substr(0, 25)
				}
				options={options}
				name={name}
				isMulti={isMulti}
				closeMenuOnSelect={!isMulti}
				hideSelectedOptions={false}
				value={
					isGroup
						? options.filter((o: any) =>
								checkByLabel ? o.label === value : o.value === value,
							)
						: value
				}
				menuPortalTarget={
					document.querySelector(".select-portal-content") as HTMLElement
				}
				styles={getReactSelectStyles(
					error && isTouched,
					error
						? {
								borderColor: "red !important",
							}
						: {},
				)}
				inputId={name}
				loadingMessage={() => "Loading options..."}
				components={{
					Option: isMulti
						? OptionWithCheckBox
						: defaultReactSelectComponent.Option,
					LoadingIndicator: () => (
						<div className="react-select-loader-indicator">
							<Loader />
						</div>
					),
					...components,
				}}
				{...rest}
			/>
			{error && <p className="error-message mt-4">{error}</p>}
		</div>
	);
};

export { Select };
